var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { ref, get, update } from 'firebase/database';
import { database, auth } from '../../config/firebaseConfig';
import mixpanel from '../../config/mixpanelConfig';
import { updateProfile } from 'firebase/auth';
// ----------------------------------------------
// Action creators
// ----------------------------------------------
export var loadUserData = createAsyncThunk('user/loadUserData', function (_, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var userId, userData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userId = getState().auth.userId;
                    return [4 /*yield*/, _fetchUserData(userId).catch(function (error) {
                            Sentry.captureException(error);
                            return Promise.reject(error);
                        })];
                case 1:
                    userData = _b.sent();
                    if (userData) {
                        mixpanel.people.set_once({
                            $email: userData.email,
                            $created: userData.dateSignedUp,
                        });
                    }
                    return [2 /*return*/, userData];
            }
        });
    });
});
export var updateUserName_firstTimeOnly = createAsyncThunk('user/updateName', function (_a, _b) {
    var firstName = _a.firstName, lastName = _a.lastName;
    var getState = _b.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var userId;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    userId = getState().user.id;
                    return [4 /*yield*/, _updateUserName_firstTimeOnly(userId, { firstName: firstName, lastName: lastName })];
                case 1:
                    _c.sent();
                    mixpanel.track("update user's name");
                    return [2 /*return*/, { firstName: firstName, lastName: lastName }];
            }
        });
    });
});
export var dismissMessage = createAsyncThunk('user/dismissMessage', function (messageID, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var userId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userId = getState().user.id;
                    return [4 /*yield*/, _setMessageVisibility(userId, messageID, true)];
                case 1:
                    _b.sent();
                    return [2 /*return*/, { messageID: messageID }];
            }
        });
    });
});
// ----------------------------------------------
// Firebase controllers
// ----------------------------------------------
var _fetchUserData = function (userId) {
    return get(ref(database, "users/".concat(userId))).then(function (snapshot) {
        var user = snapshot.val();
        if (!user) {
            return _addUserToDatabase(auth.currentUser).then(function (_user) { return _user; });
        }
        else {
            return user;
        }
    });
};
var _addUserToDatabase = function (user) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var currentDate, newUser;
        return __generator(this, function (_a) {
            currentDate = new Date().toISOString();
            newUser = {
                lastLogin: currentDate,
                email: user.email,
                id: user.uid,
                dateSignedUp: currentDate,
                _admin: {
                    termsAndConditions: {
                        v1: currentDate,
                    },
                },
                showMessage: {
                    downloadDesktopApp: false,
                    downloadBrowserExtension: false,
                },
            };
            update(ref(database, "users/".concat(user.uid)), newUser)
                .then(function () {
                console.log('added user to database', user.uid);
                resolve(newUser);
            })
                .catch(function (error) {
                console.log(error);
                reject(error);
            });
            return [2 /*return*/];
        });
    }); });
};
/**
 *
 * IMPORTANT! use this only the first time the user signs up, otherwise you are sending the Welcome email twice!
 */
var _updateUserName_firstTimeOnly = function (userId, _a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    return new Promise(function (resolve, reject) {
        update(ref(database, "users/".concat(userId)), { firstName: firstName, lastName: lastName })
            .then(function () {
            var fullName = "".concat(firstName, " ").concat(lastName);
            // EVENTS THAT SHOULD BE TRIGGERED ONLY THE FIRST TIME THE USER SIGNS UP
            // Send welcome email
            // axios.post('/api/user/welcome', { authToken, firstName })
            // ---------------------------------------------
            // ---------------------------------------------
            // OTHER EVENTS
            // Update Firebase auth
            updateProfile(auth.currentUser, {
                displayName: fullName,
            });
            // Update mixpanel
            mixpanel.people.set({
                $first_name: firstName,
                $last_name: lastName,
                $name: fullName,
            });
            resolve();
        })
            .catch(function (error) {
            console.log(error);
            reject();
        });
    });
};
var _setMessageVisibility = function (userId, messageID, value) {
    return new Promise(function (resolve, reject) {
        var _a;
        update(ref(database, "users/".concat(userId, "/showMessage")), (_a = {}, _a[messageID] = value, _a))
            .then(function () {
            resolve();
        })
            .catch(function (error) {
            console.log(error);
            reject();
        });
    });
};
